import {AsyncPage, Empty} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {createAction} from 'Shared/utilities/actionCreator';
import {UserModel} from 'Users/models/UserModel';
import {FilterOptionUnion, FilterOptionValue} from 'Core/models/FilterOption';

export enum CustomerSupportActionTypes {
  SEARCH_CUSTOMER_SUPPORTS = 'customerSupportUser/SEARCH__CUSTOMER_SUPPORTS',
  CHANGE_CUSTOMER_SUPPORT_FILTER = 'customerSupportUser/CHANGE_CUSTOMER_SUPPORT_FILTER',
  CHANGE_CUSTOMER_SUPPORTS = 'customerSupportUser/CHANGE_CUSTOMER_SUPPORTS',
  START_IMPERSONATE_CUSTOMER_SUPPORT = 'customerSupportUser/START_IMPERSONATE_CUSTOMER_SUPPORT',
  STOP_IMPERSONATION = 'customerSupportUser/STOP_IMPERSONATION',
}

export const EmptyCustomerSupportFilter: CustomerSupportFilter = {
  userName: '',
  firstName: '',
  lastName: '',
  agentNumber: '',
  linesOfBusiness: FilterOptionValue.EmptyOption(),
  applicationIds: [],
  email: '',
  exclusivityStatus: '',
};

export type CustomerSupportFilter = {
  userName: string;
  firstName: string;
  lastName: string;
  agentNumber: string;
  linesOfBusiness: FilterOptionUnion;
  applicationIds: number[];
  email: string;
  exclusivityStatus: string;
};

export const searchCustomerUsers = (
  pageOption?: Page<UserModel>,
  filter?: CustomerSupportFilter,
  encryptedIdentifier?: string,
  recruiterCodes?: string
) =>
  createAction(CustomerSupportActionTypes.SEARCH_CUSTOMER_SUPPORTS, {
    pageOption,
    filter,
    encryptedIdentifier,
    recruiterCodes,
  });
export const changeCustomerSupportFilter = (filters: CustomerSupportFilter) =>
  createAction(CustomerSupportActionTypes.CHANGE_CUSTOMER_SUPPORT_FILTER, {filters});
export const changeCustomerSupport = (subscriptions: AsyncPage<Page<UserModel>>) =>
  createAction(CustomerSupportActionTypes.CHANGE_CUSTOMER_SUPPORTS, subscriptions);

export const impersonateCustomerSuportUser = (username: string, impersonatedCustomerSupportUsername: string) =>
  createAction(CustomerSupportActionTypes.START_IMPERSONATE_CUSTOMER_SUPPORT, {
    username,
    impersonatedCustomerSupportUsername,
  });

export const stopCustomerSupportImpersonation = (username: string) =>
  createAction(CustomerSupportActionTypes.STOP_IMPERSONATION, {username});

type CustomerSupportState = {
  users: AsyncPage<Page<UserModel>>;
  filter: CustomerSupportFilter;
};

export const DEFAULT_STATE = {
  users: new Empty(),
  filter: EmptyCustomerSupportFilter,
};
export const CustomerSupportActions = {
  searchCustomerUsers,
};
type CustomerSupportAction = ReturnType<typeof changeCustomerSupportFilter> | ReturnType<typeof changeCustomerSupport>;

export default (state: CustomerSupportState = DEFAULT_STATE, action: CustomerSupportAction): CustomerSupportState => {
  switch (action.type) {
    case CustomerSupportActionTypes.CHANGE_CUSTOMER_SUPPORT_FILTER:
      return {
        ...state,
        filter: action.payload.filters,
      };
    case CustomerSupportActionTypes.CHANGE_CUSTOMER_SUPPORTS:
      return {
        ...state,
        users: action.payload,
      };
    default:
      return state;
  }
};
